import defaultMember from '@hc-frontend/shared-assets/src/js/sem/storage-manager/defaultMember'
import getMemberIdBySuffix from 'utils/pivot/member/getMemberIdBySuffix'
import saveSalesForceId from 'utils/pivot/saveSalesForceId'
import storage, { WebStorage } from 'proxy-storage'
import isNumber from 'utils/number/isNumber'
import { findApplicant, findChildren, MemberType } from '@hc-frontend/business'
import { convertToMember } from 'utils/pivot/member/convertToMember/convertToMember'

const sessionStorage = new WebStorage('sessionStorage')

function saveToStorage(valuesForm) {
  const hcStorage = storage.getItem('hc')

  hcStorage.lastHealthcareSession = hcStorage.healthcareSession

  hcStorage.contact.first_name = valuesForm.fname
  hcStorage.contact.last_name = valuesForm.lname
  hcStorage.contact.email_address = valuesForm.email
  hcStorage.contact.phone_home = valuesForm.phone
  hcStorage.childOnly = valuesForm.childOnly
  hcStorage.childOnlySMT = valuesForm.childOnlySMT
  if (hcStorage.sdate != valuesForm.sdate) {
    hcStorage.sdate = valuesForm.sdate
    hcStorage.endDate = ''
  }

  if (valuesForm.coverageType) {
    hcStorage.coverageTypeSelection = valuesForm.coverageType
  }

  let members = []

  let idChild = 0
  const keyChild = MemberType.Child.toLowerCase()
  for (const key in valuesForm) {
    const [inputName, suffix] = key.split('_')

    if (inputName === 'dob') {
      const ids = getMemberIdBySuffix(suffix)
      const member =
        hcStorage.members.find(person => person.id === ids.id) ||
        Object.assign({}, defaultMember, ids)

      const keyGender = ['gender', suffix].filter(Boolean).join('_')
      member.gender = valuesForm[keyGender]
      member.dob = valuesForm[key]

      if (isNumber(+suffix)) {
        idChild += 1
        member.id = `${keyChild}_${idChild}`
      }

      members.push(member)
    }
  }

  members = convertToMember(members)
  members[0].firstName = valuesForm.fname
  members[0].lastName = valuesForm.lname
  members[0].phone = valuesForm.phone
  hcStorage.members = valuesForm.childOnly
    ? [findApplicant(members), ...findChildren(members)].filter(Boolean)
    : members
  hcStorage.household.size = members.length

  if (valuesForm.period) {
    hcStorage.period = valuesForm.period
  }

  if (window.LeadiD && window.LeadiD.token && valuesForm.phone) {
    sessionStorage.setItem('pivotJornayaLeadIdToken', window.LeadiD.token)
  }

  saveSalesForceId(hcStorage.contact.email_address)
  storage.setItem('hc', hcStorage)

  return hcStorage
}

export default saveToStorage
